import styles from './Marquee.module.css';

interface MarqueeProps {
  items: readonly string[];
  speed?: number;
  className?: string;
}

export default function Marquee({ items, speed = 60, className = '' }: MarqueeProps) {
  const text = items.join('  ◦  ');
  return (
    <div className={`${styles.root} ${className}`}>
      <div className={styles.track} style={{ animationDuration: `${speed}s` }}>
        <span className={styles.row}>
          {text}  ◦  {text}  ◦  {text}  ◦{' '}
        </span>
        <span className={styles.row} aria-hidden="true">
          {text}  ◦  {text}  ◦  {text}  ◦{' '}
        </span>
      </div>
    </div>
  );
}
